import type { RouteObject } from "react-router";
import { Rechnungen } from "./Rechnungen";
import { RechnungDetail } from "./RechnungDetail";
import { MahnungSenden } from "./MahnungSenden";
import { RechnungErstellen } from "./RechnungErstellen";
import { RechnungDruck } from "./RechnungDruck";
import { Auszahlungen } from "./Auszahlungen";
import { BestandImport } from "../stammdaten/BestandImport";
import { Kontoauszug } from "./Kontoauszug";
import { Liquiditaet } from "./Liquiditaet";
import { NurMitBetraegen } from "../../../app/betraege";

// Rechnungen, Mahnungen, Auszahlungen, Kontoauszug und Liquidität bestehen aus Beträgen: nur mit „Beträge sehen“ (RECHTE-6)
export const rechnungenRoutes: RouteObject[] = [
  { path: "rechnungen", element: <NurMitBetraegen><Rechnungen /></NurMitBetraegen> },
  { path: "rechnungen/neu", element: <NurMitBetraegen><RechnungErstellen /></NurMitBetraegen> },
  { path: "rechnungen/import", element: <NurMitBetraegen><BestandImport kind="rechnungen" /></NurMitBetraegen> },
  // Kontoauszug abgleichen und Liquiditätsvorschau (0070)
  { path: "rechnungen/kontoauszug", element: <NurMitBetraegen><Kontoauszug /></NurMitBetraegen> },
  { path: "kennzahlen/liquiditaet", element: <NurMitBetraegen><Liquiditaet /></NurMitBetraegen> },
  { path: "rechnungen/:invoiceId", element: <NurMitBetraegen><RechnungDetail /></NurMitBetraegen> },
  { path: "rechnungen/:invoiceId/erinnern", element: <NurMitBetraegen><MahnungSenden /></NurMitBetraegen> },
  { path: "rechnungen/:invoiceId/druck", element: <NurMitBetraegen><RechnungDruck /></NurMitBetraegen> },
  { path: "auszahlungen", element: <NurMitBetraegen><Auszahlungen /></NurMitBetraegen> },
];
